import { createImmerReducer } from "utils/ReducerUtils";
import type { ReduxAction } from "actions/ReduxActionTypes";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";

export interface AIChatState {
  isProcessing: boolean;
  runId: string;
  threadId: string;
  isWaitingForResponse: boolean;
  isThreadLoading: boolean;
  isCancelling: boolean;
}

export interface AIChatReduxState {
  [stateId: string]: AIChatState;
}

export const initialAIChatState: AIChatState = {
  isProcessing: false,
  runId: "",
  threadId: "",
  isWaitingForResponse: false,
  isThreadLoading: false,
  isCancelling: false,
};

export const initialState: AIChatReduxState = {};

export const aiChatHandlers = {
  [ReduxActionTypes.AI_CHAT_SET_STATE]: (
    draft: AIChatReduxState,
    action: ReduxAction<{ stateId: string; state: Partial<AIChatState> }>,
  ) => {
    const { state, stateId } = action.payload;

    draft[stateId] = { ...draft[stateId], ...state };

    return draft;
  },
  [ReduxActionTypes.AI_CHAT_RESET_STATE]: (
    draft: AIChatReduxState,
    action: ReduxAction<{ stateId: string }>,
  ) => {
    draft[action.payload.stateId] = { ...initialAIChatState };

    return draft;
  },
};

const aiChatReducer = createImmerReducer(initialState, aiChatHandlers);

export default aiChatReducer;
